const FIREBASE_PROVIDER = "firebase";
const UPGRADE_REQUIRED_STATUS = 426;
const DISMISSED_POPUP_CODES = [
  "auth/popup-closed-by-user",
  "auth/cancelled-popup-request",
];

export const buildFirebaseSocialFields = async (userCredential) => ({
  provider: FIREBASE_PROVIDER,
  idToken: await userCredential.user.getIdToken(),
});

export const socialEmail = (userCredential) =>
  String(
    userCredential.user?.email ?? userCredential._tokenResponse?.email ?? ""
  )
    .trim()
    .toLowerCase();

export const isPopupDismissed = (error) =>
  DISMISSED_POPUP_CODES.includes(error?.code);

export const isUpgradeRequired = (error) =>
  error?.response?.status === UPGRADE_REQUIRED_STATUS;

export const getSocialAuthErrorMessage = (error, fallbackMessage) => {
  if (isUpgradeRequired(error)) {
    return fallbackMessage;
  }
  const backendMessage = error?.response?.data?.message;
  if (Array.isArray(backendMessage)) {
    return backendMessage.join(", ");
  }
  return backendMessage || fallbackMessage;
};
